import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../stores/auth";

export function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const setSession = useAuth((s) => s.setSession);
  const nav = useNavigate();

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      const { data } = await api.post("/api/auth/login", { username, password });
      setSession({ access: data.access, refresh: data.refresh, user: data.user });
      nav("/", { replace: true });
    } catch (e) {
      setErr(errMsg(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <div className="bg-navy text-white pt-12 pb-16 px-6 rounded-b-3xl">
        <div className="flex items-center gap-3">
          <span className="bg-yellow text-navy w-12 h-12 rounded-2xl grid place-items-center text-2xl font-bold">★</span>
          <div>
            <h1 className="text-2xl font-bold">TCG Inventory Hub</h1>
            <p className="text-sm opacity-80">v2.0 — FGC GROUP SRL</p>
          </div>
        </div>
      </div>
      <form onSubmit={submit} className="-mt-10 mx-6 card flex flex-col gap-4 z-10">
        <div className="flex flex-col gap-1">
          <label className="field-label">Username</label>
          <input className="field-input" value={username} onChange={(e) => setUsername(e.target.value.toLowerCase().trim())} autoFocus placeholder="facundo" autoComplete="username" />
        </div>
        <div className="flex flex-col gap-1">
          <label className="field-label">Password</label>
          <input type="password" className="field-input" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        </div>
        {err && <div className="text-red-600 text-sm">{err}</div>}
        <button className="btn-primary" disabled={busy || !username || !password}>
          {busy ? "Login…" : "Accedi"}
        </button>
      </form>
      <p className="text-center text-xs text-navy/50 mt-6">
        Le password iniziali sono in /opt/tcg-inv-hub/operator_initial_passwords.txt sul VPS.
      </p>
    </div>
  );
}
